import React, { useEffect, useState } from 'react';
import styled from 'App/styled';
import Modal from 'shared/components/Modal';
import Cart from './cart';
import { pages } from 'constants/urls';

const Iframe = styled.iframe`
  height: 100vh;
  width: 400px;
`;

interface SidebarConfig {
  hideHandler?: () => void;
}

const Component = ({ hideHandler }: SidebarConfig) => {
  const [showCouponPage, setShowCouponPage] = useState(false);

  const toggleCouponPage = () => {
    setShowCouponPage((prev) => !prev);
  };

  useEffect(() => {
    (window as any).handleCouponsBack = () => {
      setShowCouponPage(false);
    };
  }, []);

  const handler = () => {
    if (hideHandler) {
      hideHandler();
    }
  };

  const renderCartPage = () => <Cart toggleCouponPage={toggleCouponPage} />;

  const renderCouponPage = () => <Iframe src={pages.CART_COUPONS} />;

  return (
    <Modal
      modalBackground="transparent"
      onHide={handler}
      customStyle={{ width: '390px' }}
      ariaLabel="Shopping Bag"
    >
      {!showCouponPage ? renderCartPage() : renderCouponPage()}
    </Modal>
  );
};
export default Component;
